import { Headphones, MessageCircle, Phone, X } from "lucide-react";
import { INDIA_OFFICE, indiaWhatsAppUrl } from "@/lib/indiaContact";

export function ChatModal({ open, onClose }) {
  if (!open) return null;

  const whatsappUrl = indiaWhatsAppUrl();

  return (
    <div className="fixed inset-0 bg-ink/40 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl max-w-md w-full p-6 space-y-4 shadow-2xl relative border border-brand-300">
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="absolute top-3 right-3 inline-flex h-11 w-11 items-center justify-center rounded-full text-ink/60 hover:bg-brand-50 hover:text-ink"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="flex items-center gap-3 border-b pb-3">
          <div className="w-10 h-10 rounded-full bg-brand-500 text-white flex items-center justify-center font-bold">
            <Headphones className="w-5 h-5" />
          </div>
          <div>
            <h4 className="font-bold text-ink text-sm">Our Advisory Desk</h4>
          </div>
        </div>

        <p className="text-xs text-ink/70 leading-relaxed">
          Reach out to our team for programmes, consultations, and walk-in details.
        </p>

        <div className="space-y-2">
          {whatsappUrl ? (
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full min-h-[44px] bg-sun-500 hover:bg-sun-400 text-ink font-bold py-3 rounded-lg text-sm flex items-center justify-center gap-2"
            >
              <MessageCircle className="w-4 h-4" />
              WhatsApp {INDIA_OFFICE.phone}
            </a>
          ) : null}
          <a
            href={`tel:${INDIA_OFFICE.tel}`}
            className="w-full min-h-[44px] bg-brand-500 hover:bg-brand-600 text-white font-bold py-3 rounded-lg text-sm flex items-center justify-center gap-2"
          >
            <Phone className="w-4 h-4" />
            Call {INDIA_OFFICE.phone}
          </a>
        </div>
      </div>
    </div>
  );
}
